<template>
  <PVCard>
    <template v-for="(_, slot) of $slots" v-slot:[slot]="scope">
      <slot v-if="slot" :name="slot" v-bind="scope" />
    </template>
  </PVCard>
</template>

<script setup lang="ts">
import PVCard from 'primevue/card';
</script>
